import http from "./http.service";

export const getWebByPage= async (page:any)=>{
    return http.get(`/webpages/page/${page}`);
}

export const getAllWebpages= async()=>{
    return http.get(`/webpages/getAllWebpages`,{params:{limit:100,page:1}});
}
